import React from 'react';
import { jsPDF } from 'jspdf';
import "jspdf-autotable"
import autoTable from "jspdf-autotable";

export const PlantillaTransferencia = (sucursal,nombrecompania,dataresultados,titulo) => {

    const doc = new jsPDF();

    // Añadir contenido al PDF
    doc.setFontSize(16);
    //doc.text(nombrecompania, 10, 10);
    //doc.setFontSize(12);
    //doc.text(direccion, 10, 15);
  //  doc.text(telefono, 10, 20);
//    doc.text('Registro de Compras', 10, 25);

    let x = 10
    let y = 30
    
    //doc.setDrawColor(0,0,255)
    //doc.rect(10,30,90,20,"S")  //primer cuadro
    //doc.rect(110,30,90,20,"S") //segundo cuadro 
    
    // Tabla de información del proveedor
    const proveedorHeaders = [["Información General",""]];
    const proveedorData = [
        ["Proveedor:", "proveedor.labe"],
        ["Teléfono:", "proveedor.telefono"],
        ["RNC:", "proveedor.rnc"],
        ["Fecha de emision:", "fechaEmision"],
    ];

    // Generar tabla del proveedor
  //  autoTable(doc, {
//        head: proveedorHeaders,
      //  body: proveedorData,
    //    startY: 32,
  //      startX: 12,
//        tableWidth: 100,
      //  bodyStyles: {
    //        fontSize: 10,   
  //          cellPadding: 3,
//        },
        //columnStyles: {
      //      0: { cellWidth: 50, fontStyle: 'bold'},
    //        1: { cellWidth: 40 }
  //      }
//    });

    /////2da. tabla
    doc.setFontSize(17)
    doc.setFont("helvetica", "bold");
    doc.text(nombrecompania,90-nombrecompania.length,15)

    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = today.getFullYear();
    var fechaemision = 'Fecha de emision: ' + `${day}-${month}-${year}`

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10)
    doc.text(fechaemision,150,20)
 
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10)
    doc.text("Recibir en: "+sucursal,150,24)

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14)
    doc.text(titulo,15 ,40)
    

    
    //header
    const encabezados = [["Chasis","Marca","Modelo","Color","Estado"]]; 
    
    
//    const data1 = JSON.stringify(dataresultados)
//    const data2 = JSON.parse(data1)
 
    
  
    // Configuración de la tabla
    const rows = [];
    dataresultados.forEach((item) => { 
      // Fila principal
      rows.push([item.Chasis,item.Marca,item.Modelo,item.Color,item.condicion]);
    
      // Subfilas
      
    });

    // Transformar los datos para el AutoTable


    // Generar la tabl
    autoTable(doc, {
      head: encabezados,
      body: rows,//[rows],
      startY: 45, // Posición inicial

//      didParseCell: function (data) {
        
  //      if (data.row.index > 0) {
  //        if (data.row.index % 2 !== 0) {
  //          data.cell.styles.fontStyle = 'bold';
  //        } else {
            //data.cell.styles.fillColor = [245, 245, 245];
  //        }
  //      }
  //    }
      
    });
    

    const ultimaposicionY = doc.lastAutoTable.finalY
    var totalvalue = 0.0
    
 
    
//    if (dataresultados[0]['notacierre'].length != 0){
  //    posY = posY + 15
    //  posY = posY + 5
   //   doc.text("Nota de Cierre",20,posY)
   //   posY = posY + 5
     // doc.text(dataresultados[0]['notacierre'],20,posY,{align: 'left'})
  
 //   }
    


    // Abrir el PDF en una nueva pestaña
    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, '_blank');
};


